module.exports = __webpack_public_path__ + "static/media/icon_collapse.f275a61a.svg";